<template>
  <IconLucideMessageSquare />
</template>
